import { Matrix3, Matrix4, Object3D, Vector3 } from 'three';

import { Point2D as Point2DInterface, Point3D as Point3DInterface } from '@paragon/contract-library';
import { Point3D } from '@paragon/geometry-library';

export const LAYOUT_TO_DESIGN_COORDINATES_MATRIX = new Matrix4().setFromMatrix3(
  new Matrix3().fromArray([1, 0, 0, 0, 0, -1, 0, 1, 0]),
);

export function markMatrixWorldDirty(object: Object3D) {
  object.matrixWorldNeedsUpdate = true;
}

export function createLayoutToDesignTransform(position: Point3DInterface, rotationZ: number, scale: Vector3) {
  return new Matrix4()
    .makeRotationZ(rotationZ)
    .scale(scale)
    .setPosition(position.x, position.y, position.z)
    .premultiply(LAYOUT_TO_DESIGN_COORDINATES_MATRIX);
}

export function convertFromLayoutToDesignCoordinates(point: Point2DInterface | Point3DInterface) {
  return new Point3D(point.x, 'z' in point ? point.z : 0, -point.y);
}

export const DESIGN_TO_LAYOUT_COORDINATES_MATRIX = new Matrix4().setFromMatrix3(
  new Matrix3().fromArray([1, 0, 0, 0, 0, 1, 0, -1, 0]),
);

export function convertFromDesignToLayoutCoordinates(point: Point2DInterface | Point3DInterface) {
  return new Point3D(point.x, 'z' in point ? -point.z : 0, point.y);
}
